import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaBars, FaTimes } from 'react-icons/fa';
import './Navbar.css';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 50;
      setScrolled(isScrolled);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <nav className={`navbar ${scrolled ? 'navbar-scrolled' : ''}`}>
      <div className="navbar-container">
      <Link to="/" className="navbar-logo" onClick={closeMenu}>
      <img
              src="https://hebbkx1anhila5yf.public.blob.vercel-storage.com/fox-WINbJ6Ld7qekNeWd6hvFR4KRD7pnqJ.png"
              alt="Redfox Digital Logo"
              className="fox-logo"
            />
          <div className="logo-container">  
            <span className="logo-text">Redfox</span>
            <span className="logo-subtext">Digital</span>
          </div>
        </Link>

        <div className={`navbar-menu ${isMenuOpen ? 'active' : ''}`}>
          <Link 
            to="/" 
            className={`navbar-link ${location.pathname === '/' ? 'active' : ''}`}
            onClick={closeMenu}
          >
            Home
          </Link>
          {/*<Link 
            to="/about" 
            className={`navbar-link ${location.pathname === '/about' ? 'active' : ''}`}
            onClick={closeMenu}
          >
            About Us
          </Link>*/}
          <Link 
            to="/services" 
            className={`navbar-link ${location.pathname === '/services' ? 'active' : ''}`}
            onClick={closeMenu}
          >
            Services
          </Link>
          {/*<Link 
            to="/portfolio" 
            className={`navbar-link ${location.pathname === '/portfolio' ? 'active' : ''}`}
            onClick={closeMenu}
          >
            Portfolio
          </Link>*/}
          <Link 
            to="/contact" 
            className={`navbar-link ${location.pathname === '/contact' ? 'active' : ''}`}
            onClick={closeMenu}
          >
            Contact
          </Link>
          <Link 
            to="/pricing" 
            className={`navbar-link ${location.pathname === '/pricing' ? 'active' : ''}`}
            onClick={closeMenu}
          >
            Pricing
          </Link>
          <Link 
            to="/terms" 
            className={`navbar-link ${location.pathname === '/terms' ? 'active' : ''}`}
            onClick={closeMenu}
          >
            Terms
          </Link>
          <Link 
            to="/privacy" 
            className={`navbar-link ${location.pathname === '/privacy' ? 'active' : ''}`}
            onClick={closeMenu}
          >
            Privacy Policy
          </Link>
          <Link 
            to="/refund-policy" 
            className={`navbar-link ${location.pathname === '/refund-policy' ? 'active' : ''}`}
            onClick={closeMenu}
          >
            Refund Policy
          </Link>
          <Link to="/contact" className="btn btn-primary navbar-cta" onClick={closeMenu}>
            Get a Quote
          </Link>
        </div>

        <div className="navbar-toggle" onClick={toggleMenu}>
          {isMenuOpen ? <FaTimes /> : <FaBars />}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;